module.exports = __webpack_public_path__ + "assets/img/icon_warm_up.63785301.png";